export function isSuperAdmin(user) {
  return Boolean(user?.isSuperAdmin || user?.globalRole === "superadmin");
}

export function isStaff(user) {
  return Boolean(user?.globalRole === "staff");
}

export function canManageWebProfit(user) {
  return isSuperAdmin(user);
}

export function isPlatformOwner(user) {
  return Boolean(user?.isPlatformOwner === true || ["owner", "superowner"].includes(user?.platformRole));
}
